import React from 'react';
import '../styles/Switch.css';

const Switch = ({ isToggled, onToggle }) => {
    return (
        <div className="d-flex justify-content-end">
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onToggle} />
                <span className="slider round"></span>
            </label>
        </div>
    );
};

export default Switch;
